export * from './LoginSrOnly'
export * from './AboutUsSrOnly'
export * from './ContactSrOnly'
export * from './RegisterSrOnly'
export * from './ComingSoonSrOnly'
export * from './ResetPasswordSrOnly'
